export default "__VITE_ASSET__b4c27065__"